import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { getRecords, saveRecords } from "../../../services/api.service";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";

const UserTypeAccess = () => {
  const userType = [
    { label: "Bermad User", value: 1 },
    { label: "Subcontractor", value: 2 },
    { label: "Customer", value: 3 },
  ];
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [userlistOptions] = useState(userType);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [UserTypeError, setUserTypeError] = useState(false);

  const handleUserSelectChange = (userType) => {
    setSelectedUserType(userType);
    setUserTypeError(false);
    setData([]);
  };

  const handleGo = async () => {
    if (!selectedUserType) {
      setUserTypeError(!selectedUserType ? true : false);
      return;
    }

    const payload = {
      modelName: "menu_masters",
      whereCondition: {
        is_active: true,
      },
      pagination: { page: 1, pageSize: 1000000 },
      relations: [
        {
          module: "user_type_menu_access",
          moduleAs: "user_type_menu_access",
          isModuleWhereConditionRequired: true,
        },
      ],
      moduleWhereCondition: {
        user_type: selectedUserType?.value,
        is_active: true,
      },
    };

    setLoading(true);
    const responseData = await getRecords(payload, "/getRecords");
    setLoading(false);

    if (responseData?.data?.length > 0) {
      const updatedData = responseData?.data?.map((item) => {
        // Check if the user has access in the user_type_menu_access array
        const userTypeAccess = item?.user_type_menu_access.find(
          (access) => access?.access === true
        );
        return {
          ...item,
          isChecked: userTypeAccess ? true : false,
          primary_id:
            item?.user_type_menu_access?.map((user) => user.id)[0] ?? null,
        };
      });
      setData(updatedData);
    } else {
      setData([]);
      toast.info("No menu found for the selected user type.");
    }
  };

  const handleToggleExpand = (id) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isExpanded: !item.isExpanded } : item
      )
    );
  };

  const handleCheckboxChange = (id, checked) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id || item.parent_id === id
          ? { ...item, isChecked: checked }
          : item
      )
    );

    if (checked) {
      const childParentMenuId = data
        .filter((child) => child.id === id)
        .map((child) => child.parent_id)[0];
      if (childParentMenuId) {
        setData((prev) =>
          prev.map((item) =>
            item.id === childParentMenuId
              ? { ...item, isChecked: checked }
              : item
          )
        );
      }
    }
  };
  const handleSubmit = async () => {
    if (!selectedUserType) {
      toast.error("Please select a user type.");
      return;
    }
    const checkedUsers = data
      .filter((user) => user.isChecked)
      .map((user) => user.id); // Extract their IDs
    // Ensure at least one user is selected
    if (checkedUsers.length === 0) {
      toast.error("Please select at least one user.");
      return;
    }
    setLoading(true);
    const payload = {
      modelName: "user_type_menu_access",
      inputData: data.map((item) => ({
        id: item.primary_id, // Use primary_id (the ID from user_type_menu_access)
        user_type: selectedUserType?.value, // Use selected user type value
        menu_id: item.id,
        access: item.isChecked ?? false,
        is_active: true,
      })),
    };
    // API call to save the records
    try {
      const response = await saveRecords(payload, "/saveRecords");

      if (response.code === 1) {
        setData([]);
        setSelectedUserType(null);
        toast.success("Access successfully updated.");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        toast.error("Failed to update access.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An error occurred while submitting data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="USER TYPE ACCESS" breadcrumbItems={[]} />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row className="justify-content-center ">
                      <Col md={4}>
                        <SelectInput
                          label="User Type"
                          value={selectedUserType}
                          onSelect={handleUserSelectChange}
                          options={userlistOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (UserTypeError && "Please select a user type.") ||
                            ""
                          }
                        />
                      </Col>

                      <Col style={{ marginTop: "28px", paddingBottom: "20px" }}>
                        <Button
                          onClick={handleGo}
                          color="primary"
                          type="button"
                          className="waves-effect waves-light me-1"
                          style={{ background: "#006eb9" }}
                        >
                          Go
                        </Button>
                      </Col>
                    </Row>
                    <Row
                      className="justify-content-center table mt-2"
                      style={{
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "55vh",
                        width: "100%",
                        scrollBehavior: "smooth",
                        scrollbarWidth: "thin",
                        msOverflowStyle: "none",
                        zIndex: 0,
                      }}
                    >
                      {loading ? (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <Spinner color="primary" />
                        </div>
                      ) : (
                        <Row style={{ width: "100%" }}>
                          <Col xl="12">
                            <table className="table table-bordered">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  zIndex: 1,
                                }}
                              >
                                <tr>
                                  <th>Menu Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.length > 0 ? (
                                  data
                                    .filter((item) => item.parent_id === null)
                                    .map((parent) => (
                                      <React.Fragment key={parent.id}>
                                        <tr>
                                          <td
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() =>
                                              handleToggleExpand(parent.id)
                                            }
                                          >
                                            {parent.isExpanded ? "▼" : "▶"}{" "}
                                            {parent.menu_name}
                                          </td>
                                          <td>
                                            <CheckboxInput
                                              value={parent?.isChecked}
                                              checked={parent?.isChecked}
                                              handleTextChange={(e) =>
                                                handleCheckboxChange(
                                                  parent?.id,
                                                  e.target.checked
                                                )
                                              }
                                              parentClassName="form-check"
                                              checkBoxClassName="form-check-input"
                                              labelClassName="form-check-label"
                                              labelStyle={{
                                                display: "none",
                                              }}
                                              checkboxStyle={{
                                                width: "16px",
                                                height: "16px",
                                                zIndex: 0,
                                              }}
                                            />
                                          </td>
                                        </tr>
                                        {parent.isExpanded &&
                                          data
                                            ?.filter(
                                              (child) =>
                                                child.parent_id === parent.id
                                            )
                                            .map((child) => (
                                              <tr
                                                key={child.id}
                                                style={{
                                                  paddingLeft: "20px",
                                                }}
                                              >
                                                <td>
                                                  &emsp;↳ {child.menu_name}
                                                </td>
                                                <td>
                                                  <CheckboxInput
                                                    value={child?.isChecked}
                                                    checked={child?.isChecked}
                                                    handleTextChange={(e) =>
                                                      handleCheckboxChange(
                                                        child?.id,
                                                        e.target.checked
                                                      )
                                                    }
                                                    parentClassName="form-check"
                                                    checkBoxClassName="form-check-input"
                                                    labelClassName="form-check-label"
                                                    labelStyle={{
                                                      display: "none",
                                                    }}
                                                    checkboxStyle={{
                                                      width: "16px",
                                                      height: "16px",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            ))}
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="2"
                                      style={{ textAlign: "center" }}
                                    >
                                      No menus found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      )}
                    </Row>

                    {data.length > 0 && (
                      <Row className="mt-4 justify-content-center">
                        <Col
                          style={{
                            paddingTop: "10px",
                            borderTop: "1px solid #ced4da",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <Button color="primary" onClick={handleSubmit}>
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserTypeAccess;
